"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get extractProps () {
        return _nocodbsdk.extractProps;
    },
    get extractPropsAndSanitize () {
        return extractPropsAndSanitize;
    }
});
const _isomorphicdompurify = /*#__PURE__*/ _interop_require_default(require("isomorphic-dompurify"));
const _nocodbsdk = require("nocodb-sdk");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function extractPropsAndSanitize(body, props) {
    // todo: throw error if no props found
    return props.reduce((o, key)=>{
        if (key in body) o[key] = body[key] === '' ? null : _isomorphicdompurify.default.sanitize(body[key]);
        return o;
    }, {});
}
